export default {
  title: 'Rola',
  type: 'object',
  properties: {
    name: {
      title: 'Nazwa roli',
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },

    parent: {
      type: 'object',
      properties: {
        id: {
          type: 'number',
          fieldRequired: false
        }
      }
    }
  }
};
